package acupoint.containers

import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import react.*
import react.dom.div
import setTitle
import acupoint.components.AcupointNoteEdit

external interface AcupointNoteEditPageProps : RProps {
    var acupointId: String
    var noteId: String
}

data class AcupointNoteEditPageContextData(
    var save: (comment: Comment, okCallback: (result: ApiResponse<Comment>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getCommentById: (id: String, okCallback: (result: ApiResponse<Comment>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val AcupointNoteEditPageContext = createContext(AcupointNoteEditPageContextData(CommentApiClient::save, CommentApiClient::getCommentById))

val AcupointNoteEditPageProvider = functionalComponent<AcupointNoteEditPageProps> { props ->

    setTitle("穴位笔记编辑")

    useEffectOnce { }

    AcupointNoteEditPageContext.Provider(AcupointNoteEditPageContextData(CommentApiClient::save, CommentApiClient::getCommentById)) {
        div("AcupointNoteEditPage-page") {
            child(AcupointNoteEdit) {
                attrs {
                    acupointId = props.acupointId
                    noteId = props.noteId
                }
            }
        }
    }
}
